import {Component} from 'react'

import SubmitButton from '../../../../components/Forms/AvailabilityForm/SubmitButton.jsx'
import AvailabilityForm from '../../../../components/Forms/AvailabilityForm/AvailabilityForm.jsx'
import Loader from '../../../../../shared/components/Loader/Loader.jsx'
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx"

export class Availability extends Component {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  submit = async (values) => {
    return this.props.submit({
      freelance: values,
    })
  }

  render() {
    return (
      <FreelancePage className="p-5">
        <div className="step-publish p-5">
          <h2 className="text-center">Disponibilité / Visibilité</h2>
          <p className="text-center mb-5">
            Vous venez de remplir votre profil, nous pouvons maintenant le publier pour permettre
            au donneur d'ordre de vous contacter.
          </p>
          {this.props.freelance && this.props.user &&
          <AvailabilityForm
            keepDirtyOnReinitialize={false}
            enableReinitialize={true}
            onSubmit={this.submit}
            initialValues={{
              date_available: this.props.freelance?.date_available ?? null,
              public: this.props.freelance?.public ?? true
            }}
            onSubmitSuccess={this.props.onFormSuccess}
            withPublic={true} />}
          <p className="mt-5 text-center">
            <SubmitButton className="btn btn-primary">
              Sauvegarder
            </SubmitButton>
          </p>
        </div>
        <Loader visible={this.state.loading}>
          Sauvegarde en cours...
        </Loader>
      </FreelancePage>
    )
  }
}

export default Availability